export const REDUCER_NAME = 'STATISTICS'

